import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// import 'hammerjs';

declare let __webpack_public_path__: any;

if (environment.production) {
  enableProdMode();
  if (window['ebbCdn']) {
    __webpack_public_path__ = window['ebbCdn'];
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
